import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalService } from 'src/app/@shared/services/modal/modal.service';
import { StopFullData } from 'src/app/modules/route-planner/interfaces/route-planning/service/@schedule-service.interface';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import { SearchStationDetailedResultComponent } from '../../search-station-detailed-result/search-station-detailed-result.component';
import { SpecialMessage } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/special-messages/special-message.interface';
import { eSpecialMessagesEffects } from 'src/app/modules/route-planner/constants/special-messages.constants';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import {
  ALTERNATIVE_STATION,
  EXTENDED_DETAILS,
  LINES_AT_STATION,
  SPECIAL_MESSAGES,
  specialMessagesButtonAriaLabel,
  stationCardAriaLabel,
  STATION_CANCELLED,
  STATION_CODE,
} from 'src/app/modules/route-planner/constants/multi-language.constants';
import { Direction } from '@angular/cdk/bidi';

@Component({
    selector: 'app-search-stations-result-list-item',
    templateUrl: './search-stations-result-list-item.component.html',
    styleUrls: ['./search-stations-result-list-item.component.scss'],
    standalone: false
})
export class StationsResultListItemComponent implements OnInit {
  @Output() onPickStation: EventEmitter<void> = new EventEmitter();
  @Output() onFoucs = new EventEmitter<StopFullData>();

  @Input() station: StopFullData;
  /**
   * a11y: 1-based position of this card inside the parent <ul> in
   * search-stations-result-list. Bound to aria-posinset.
   */
  @Input() positionInSet: number | null = null;
  /**
   * a11y: total cards in the parent <ul>. Bound to aria-setsize so SR
   * announces "card N of M" alongside the card name.
   */
  @Input() setSize: number | null = null;

  specialMessagesText: string = 'הודעות מיוחדות';
  specialMessagesAriaLabel: string;
  stationCodeText: string;
  extendedDetailsText: string;
  /**
   * a11y: dedicated aria-label for the bottom "Extended details" mot-button.
   * Without it, SR users hear just "Extended details, button" with no clue
   * which station it belongs to. We prefix the station name so the
   * announcement becomes "Extended details, Western Wall, button".
   */
  extendedDetailsAriaLabel: string = '';
  stationCancelledText: string;
  alternativeStationText: string;
  /**
   * a11y: combined accessible name for the whole card (station name +
   * code + number of lines). Bound to the outer <section> aria-label so
   * SR reads the card identity once before stepping into its content.
   */
  cardAriaLabel: string = '';

  specialMessagesCounter: number;
  allSpecialMessages: SpecialMessage[];
  isStationCancled: boolean;
  stationName: string;

  direction: Direction;

  constructor(
    private readonly modalService: ModalService,
    private readonly languageService: LanguageService
  ) {}

  ngOnInit(): void {
    this.specialMessagesCounter = this.station.specialMessages.length;

    const routesMessages = [];
    this.station.routesInStop.forEach((station) =>
      routesMessages.push(...station.specialMessages)
    );
    this.allSpecialMessages = [
      ...this.station.specialMessages,
      ...routesMessages,
    ];

    this.isStationCancled = this.station.specialMessages.some(
      (message: SpecialMessage) =>
        message.effect.id === eSpecialMessagesEffects.NO_SERVICE ||
        message.effect.id === eSpecialMessagesEffects.DETOUR ||
        message.effect.id === eSpecialMessagesEffects.STOP_MOVED
    );
    this.initializeMultiLanguageTexts();
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe((language) => {
      this.specialMessagesText = SPECIAL_MESSAGES[language.language];
      this.specialMessagesAriaLabel = specialMessagesButtonAriaLabel(
        language.language,
        this.specialMessagesText,
        this.specialMessagesCounter
      );
      this.stationCodeText = STATION_CODE[language.language];
      this.extendedDetailsText = EXTENDED_DETAILS[language.language];
      this.stationCancelledText = STATION_CANCELLED[language.language];
      this.alternativeStationText = ALTERNATIVE_STATION[language.language];
      this.stationName = this.station.name[language.symbol] || this.station.name.he || this.station.name ||'';
      const linesCount = this.station.routesInStop?.length ?? 0;
      this.cardAriaLabel = stationCardAriaLabel(
        language.language,
        this.stationName,
        this.stationCodeText,
        this.station.stopcode,
        linesCount,
        LINES_AT_STATION[language.language]
      );
      this.extendedDetailsAriaLabel = `${this.extendedDetailsText}, ${this.stationName}`;
    });
  }

  openSpecialMessages() {
    this.modalService.openSpecialMessagesModal(this.allSpecialMessages);
  }
}
